<template>
    <!-- 库存盘点 -->
    <div>
        <content-view>
            <template slot="header">
                <div class="pl16">
                    请选择进行盘点仓库：
                    <a-select :options="warehouseOptions" v-model="warehouseId" placeholder="请选择" style="width: 200px;"></a-select>
                </div>
                <a-divider></a-divider>
                <a-form :form="filterForm" layout="inline" class="store-one-form">
                    <a-form-item label="商品编号">
                        <a-input placeholder="请输入" v-decorator="['goodsNo']"></a-input>
                    </a-form-item>
                    <a-form-item label="商品条形码">
                        <a-input placeholder="请输入" v-decorator="['goodsBarCode']"></a-input>
                    </a-form-item>
                    <a-form-item label="商品名称">
                        <a-input placeholder="请输入" v-decorator="['goodsName']"></a-input>
                    </a-form-item>
                    <a-form-item label="商品分组">
                        <a-select :options="typeOptions" placeholder="请选择" v-decorator="['goodsCategoryId']"></a-select>
                    </a-form-item>
                    <a-form-item label="使用类型">
                        <a-select placeholder="请选择" v-decorator="['useType']">
                            <a-select-option value="1">售卖</a-select-option>
                            <a-select-option value="2">自用</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button type="primary" :loading="searchLoading" @click="search">筛选</a-button>
                        <a-button @click="handleReset()" :loading="searchLoading">重置</a-button>
                    </a-form-item>
                </a-form>
            </template>
            <div class="wrap-container-in">
                <a-table
                bordered
                :columns="columns"
                :dataSource="dataSource"
                :pagination="pagination"
                :rowKey="record => record.id"
                :loading="searchLoading"
                @change="changePage"
                class="wrap-table"
                >
                    <template slot="useType" slot-scope="key, row, index">
                        {{['', '售卖', '自用'][key]}}
                    </template>
                    <template slot="empty" slot-scope="key, row, index">
                        {{key || "-"}}
                    </template>
                    <template slot="storeNum" slot-scope="key, row, index">
                        <a-input-number @change="change($event, row)" v-model="row.num" placeholder="请输入" />
                        <div v-if="row.showError" class="text-fail">请输入0或正整数</div>
                    </template>
                    <template slot="remark" slot-scope="key, row, index">
                        <a-input placeholder="请输入(20字内)" v-model="row.remark" :maxLength="20" style="width: 150px;" />
                    </template>
                </a-table>
                <a-divider></a-divider>
                <div class="text-center">
                    <a-button type="primary" :loading="submitLoading" @click="selfCheckStorageConfirm">提交</a-button>
                </div>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    const columns = [
        {
            title: '商品编号',
            dataIndex: 'goodsNo'
        },
        {
            title: '商品条形码',
            dataIndex: 'goodsBarCode',
            scopedSlots: { customRender: 'empty' }
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification'
        },
        {
            title: '基本单位',
            dataIndex: 'goodsUnit'
        },
        {
            title: '商品分组',
            dataIndex: 'categoryName'
        },
        {
            title: '使用类型',
            dataIndex: 'useType',
            scopedSlots: { customRender: 'useType'}
        },
        {
            title: '当前仓库库存数',
            dataIndex: 'currentInventory'
        },
        {
            title: '盘点库存量确认',
            scopedSlots: { customRender: 'storeNum' }
        },
        {
            title: '备注',
            scopedSlots: { customRender: 'remark' }
        },
    ];
    export default {
        name: 'materielInventoryCheck',
        components: {},
        props: {},
        data() {
            return {
                columns,
                typeOptions:[],
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                warehouseOptions: [],
                warehouseId: undefined,
                submitLoading: false,
                searchLoading: false
            };
        },
        watch: {
            shopId() {
                this.pagination.current = 1;
                this.getWarehouseList();
            }
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            /**
             * @change 入库数输入回调
             */
            change(val, record) {
                if (val === null || typeof val === 'undefined') {
                    return false;
                }
                const regExp = /^\d*$/;
                record.showError = !regExp.test(val);
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.selfCheckStoragePage();
            },
            // 重置筛选
            handleReset() {
                this.filterForm.resetFields();
                this.search();
            },
            search() {
                this.pagination.current = 1;
                this.selfCheckStoragePage();
            },
            /**
             * @getWarehouseList 获取门店下仓库列表
             */
            getWarehouseList() {
                if (!this.shopId) {
                    return false;
                }
                this.$api.newStorage.selfWarehousePage({
                    body: {
                        shopId: this.shopId,
                        pageNum: 1,
                        pageSize: 999999
                    }
                }).then(res => {
                    if (res && res.data) {
                        res.data.forEach(item => {
                            item.label = item.warehouseName;
                            item.value = item.id;
                        });
                        if (Boolean(res.data[0])) {
                            this.warehouseId = res.data[0].id;
                        }
                        this.warehouseOptions = res.data;
                        this.getGoodsCateList();
                        this.selfCheckStoragePage();
                    }
                });
            },
            /**
             * @getGoodsCateList 获取商品类别
             */
            getGoodsCateList() {
                this.$api.newStorage.getSelfGoodsCateList({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        res.forEach(item => {
                            item.label = item.categoryName;
                            item.value = item.id;
                        });
                        this.typeOptions = res;
                    }
                });
            },
            /**
             * @selfCheckStoragePage 获取盘点商品
             */
            selfCheckStoragePage() {
                this.filterForm.validateFields((errors, values) => {
                    if (errors) return;
                    this.searchLoading = true;
                    this.$api.newStorage.selfCheckStoragePage({
                        body: {
                            ...values,
                            shopId: this.shopId,
                            warehouseId: this.warehouseId,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        }
                    }).then(res => {
                        if (res && res.data) {
                            res.data.forEach(item => {
                                item.num = undefined;
                                item.remark = undefined;
                                item.showError = false;
                            });
                            this.dataSource = res.data;
                        }
                        this.pagination.total = res.total;
                        this.searchLoading = false;
                    }).catch(err => {
                        this.searchLoading = false;
                    });
                });
                
            },
            /**
             * @selfCheckStorageConfirm 商品库存盘点
             */
            selfCheckStorageConfirm() {
                if (this.submitLoading) {
                    return false;
                }
                let hasEmpty = this.dataSource.find(item => {
                    const regExp = /^\d*$/;
                    if (!Boolean(item.num) && item.num !== 0 || !regExp.test(item.num)) {
                        this.$message.error(`请输入编号“${item.goodsNo}”商品的正确库存数量！`);
                        return true;
                    }
                    if (!Boolean(item.remark)) {
                        this.$message.error(`请输入编号“${item.goodsNo}”商品的盘点备注！`);
                        return true;
                    }
                    return false;
                });
                if(Boolean(hasEmpty)) {
                    return false;
                }
                let goodsList = this.dataSource.map(item => {
                    return {
                        goodsId: item.id,
                        num: item.num,
                        remark: item.remark
                    }
                });
                this.submitLoading = true;
                this.$api.newStorage.selfCheckStorageConfirm({
                    body: {
                        checkUserName: this.userInfo.name,
                        goodsList,
                        shopId: this.shopId,
                        warehouseId: this.warehouseId
                    }
                }).then(res => {
                    this.submitLoading = false;
                    setTimeout(() => {
                        this.$router.back();
                    }, 300);
                }).catch(err => {
                    this.submitLoading = false;
                });
            }
        },
        beforeCreate() {
            this.filterForm = this.$form.createForm(this);
            this.userInfo = this.$userInfoTool.getUser();
        },
        created() {},
        mounted() {
            this.getWarehouseList();
        },
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.tabs-bar-no-margin {
    .ant-tabs-top-bar {
        margin: 0!important;
    }
}
</style>
